export default __webpack_public_path__ + "static/photo-xavier-df8bfe0397a9479e5f5da879c70f436c.webp";